import styles from "./navigation.module.css";
import documentTypeButtonGroupItems from "Areas/SharedFeatures/documentTypeButtonGroupItems";
import { Chip } from "UiKit";
import React from "react";
function Navigation({ documentType, activeDocumentId, onChangeDocumentType }) {
    const onClick = (itemData) => {
        if (itemData.key !== documentType)
            activeDocumentId &&
                (onChangeDocumentType === null || onChangeDocumentType === void 0 ? void 0 : onChangeDocumentType(activeDocumentId, itemData.key));
    };
    return (React.createElement("div", { className: styles.container }, documentTypeButtonGroupItems.map(item => (React.createElement(Chip, { onClick: () => {
            onClick(item);
        }, size: "md", styleType: "primary", key: item.key, isActive: item.key === documentType },
        React.createElement("div", { className: styles.item },
            React.createElement("i", { className: item.icon }),
            React.createElement("span", null, item.text)))))));
}
export default Navigation;
